

function addPlugins(config, slot_name, plugins) {
  if (slot_name in config.pluginSlots === false) {
    config.pluginSlots[slot_name] = {
      keepDefault: true,
      plugins: []
    };
  }

  config.pluginSlots[slot_name].plugins.push(...plugins);
}

async function setConfig () {
  let config = {
    pluginSlots: {}
  };

  try {
    /* We can't assume FPF exists, as it's not declared as a dependency in all
     * MFEs, so we import it dynamically. In addition, for dynamic imports to
     * work with Webpack all of the code that actually uses the imported module
     * needs to be inside the `try{}` block.
     */
    const { DIRECT_PLUGIN, PLUGIN_OPERATIONS } = await import('@openedx/frontend-plugin-framework');// TBA — Global MFE CSS injection (applies to ALL MFEs)
// Injects the TBA design system: Ubuntu font, TBA green/amber palette,
// polished buttons, form fields, cards, navigation, progress bars.
// No DOM structure is modified; only CSS is injected.
(function() {
  var TBA_GLOBAL_CSS = [
    '/* ========================================================',
    '   TBA Global MFE Design System',
    '   Brand: #004337 (dark green)  |  #eb8f00 (amber)',
    '   Font : Ubuntu (Google Fonts)',
    '   ======================================================== */',

    /* --- Base typography --- */
    'body, html, button, input, select, textarea {',
    '  font-family: \'Ubuntu\', \'Helvetica Neue\', Arial, sans-serif !important;',
    '}',

    /* --- MFE Shared Header --- */
    '.site-header-desktop, .site-header-mobile,',
    '.learning-header, header.site-header,',
    'header[class*="learning-header"] {',
    '  background-color: #004337 !important;',
    '  border-bottom: 2px solid #FFC745 !important;',
    '}',
    /* Header links — exclude dropdown items which need dark text on white bg */
    '.site-header-desktop .btn:not(.dropdown-item), .site-header-mobile .btn:not(.dropdown-item),',
    '.site-header-desktop a:not(.dropdown-item), .site-header-mobile a:not(.dropdown-item) {',
    '  color: #ffffff !important;',
    '}',
    '.site-header-desktop .btn:not(.dropdown-item):hover, .site-header-mobile .btn:not(.dropdown-item):hover,',
    '.site-header-desktop a:not(.dropdown-item):hover, .site-header-mobile a:not(.dropdown-item):hover {',
    '  color: #FFC745 !important;',
    '}',
    /* Dropdown menu items — always dark text regardless of header context */
    '.dropdown-menu .dropdown-item,',
    '.dropdown-menu a, .dropdown-menu button {',
    '  color: #374151 !important;',
    '}',
    /* Header nav-links — hover/active/focus → vert plus foncé */
    '.site-header-desktop .main-nav .expanded .nav-link,',
    '.site-header-desktop .main-nav .nav-link.active,',
    '.site-header-desktop .main-nav .nav-link:focus,',
    '.site-header-desktop .main-nav .nav-link:hover,',
    '.site-header-desktop .secondary-menu-container .expanded .nav-link,',
    '.site-header-desktop .secondary-menu-container .nav-link.active,',
    '.site-header-desktop .secondary-menu-container .nav-link:focus,',
    '.site-header-desktop .secondary-menu-container .nav-link:hover {',
    '  background: #002b23 !important;',
    '}',

    /* --- Links --- */
    'a { color: #eb8f00; }',
    'a:hover, a:focus { color: #004337; text-decoration: none; }',

    /* --- Buttons: Brand (primary CTA) --- */
    '.btn-brand,',
    'button.btn-brand,',
    '.pgn__stateful-btn.btn-brand,',
    '[class*="pgn__stateful-btn"].btn-brand {',
    '  background-color: #eb8f00 !important;',
    '  border-color: #eb8f00 !important;',
    '  color: #ffffff !important;',
    '  font-weight: 600 !important;',
    '  border-radius: 6px !important;',
    '  padding: 0.625rem 1.75rem !important;',
    '  letter-spacing: 0.2px !important;',
    '  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease !important;',
    '}',
    '.btn-brand:hover, .btn-brand:focus,',
    'button.btn-brand:hover, button.btn-brand:focus {',
    '  background-color: #d47e00 !important;',
    '  border-color: #d47e00 !important;',
    '  color: #ffffff !important;',
    '  box-shadow: 0 4px 12px rgba(235, 143, 0, 0.35) !important;',
    '  text-decoration: none !important;',
    '}',

    /* --- Buttons: Primary (secondary role) --- */
    '.btn-primary {',
    '  background-color: #004337 !important;',
    '  border-color: #004337 !important;',
    '  color: #ffffff !important;',
    '  font-weight: 600 !important;',
    '  border-radius: 6px !important;',
    '}',
    '.btn-primary:hover, .btn-primary:focus {',
    '  background-color: #002e26 !important;',
    '  border-color: #002e26 !important;',
    '  color: #ffffff !important;',
    '}',

    /* --- Buttons: Outline primary --- */
    '.btn-outline-primary {',
    '  color: #004337 !important;',
    '  border-color: #004337 !important;',
    '  font-weight: 600 !important;',
    '  border-radius: 6px !important;',
    '}',
    '.btn-outline-primary:hover, .btn-outline-primary:focus {',
    '  background-color: #004337 !important;',
    '  color: #ffffff !important;',
    '}',

    /* --- Buttons: Tertiary / Link --- */
    '.btn-tertiary { color: #eb8f00 !important; }',
    '.btn-tertiary:hover, .btn-tertiary:focus { color: #d47e00 !important; }',
    '.btn-link { color: #eb8f00 !important; }',
    '.btn-link:hover, .btn-link:focus { color: #d47e00 !important; }',

    /* --- Paragon brand-link (default is pink #9d0054) → amber --- */
    '.pgn__hyperlink.brand-link, a.brand-link,',
    '.standalone-link.brand-link {',
    '  color: #eb8f00 !important;',
    '}',
    '.pgn__hyperlink.brand-link:hover, a.brand-link:hover {',
    '  color: #d47e00 !important;',
    '}',

    /* --- Form Controls --- */
    '.form-control, .pgn__form-control,',
    'input.form-control, select.form-control, textarea.form-control {',
    '  border-radius: 6px !important;',
    '  border: 1px solid #d1d5db !important;',
    '  font-family: \'Ubuntu\', sans-serif !important;',
    '  transition: border-color 0.15s ease, box-shadow 0.15s ease !important;',
    '}',
    '.form-control:focus, .pgn__form-control:focus,',
    'input.form-control:focus, textarea.form-control:focus {',
    '  border-color: #eb8f00 !important;',
    '  box-shadow: 0 0 0 3px rgba(235, 143, 0, 0.18) !important;',
    '  outline: none !important;',
    '}',

    /* Floating label — amber when focused */
    '.form-group__form-field .form-control:focus ~',
    '  .pgn__form-control-floating-label .pgn__form-control-floating-label-content {',
    '  color: #eb8f00 !important;',
    '}',

    /* --- Checkbox & Radio accent colour --- */
    'input[type="checkbox"], input[type="radio"] {',
    '  accent-color: #eb8f00 !important;',
    '}',

    /* --- Cards --- */
    '.pgn__card, .card {',
    '  border: none !important;',
    '  border-radius: 10px !important;',
    '  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06) !important;',
    '  transition: box-shadow 0.2s ease, transform 0.2s ease !important;',
    '}',

    /* --- Progress bars --- */
    '.progress {',
    '  border-radius: 10px !important;',
    '  background-color: #e5e7eb !important;',
    '}',
    '.progress-bar {',
    '  background-color: #eb8f00 !important;',
    '  border-radius: 10px !important;',
    '}',

    /* --- Navigation tabs --- */
    '.nav-tabs .nav-link {',
    '  color: #6b7280 !important;',
    '  font-weight: 500 !important;',
    '  border-bottom: 3px solid transparent !important;',
    '}',
    '.nav-tabs .nav-link.active,',
    '.nav-tabs .nav-item.show .nav-link {',
    '  color: #004337 !important;',
    '  border-bottom: 3px solid #eb8f00 !important;',
    '  font-weight: 700 !important;',
    '  background-color: transparent !important;',
    '}',
    '.nav-tabs .nav-link:hover:not(.active) {',
    '  color: #eb8f00 !important;',
    '  border-bottom-color: rgba(235, 143, 0, 0.35) !important;',
    '}',

    /* --- Badges --- */
    '.badge-primary { background-color: #eb8f00 !important; color: #ffffff !important; }',

    /* --- Alert info --- */
    '.alert-info {',
    '  background-color: #e8f2f0 !important;',
    '  border-color: #b3d4ce !important;',
    '  color: #004337 !important;',
    '}',

    /* --- Spinner / loading --- */
    '.spinner-border {',
    '  border-color: rgba(235, 143, 0, 0.2) !important;',
    '  border-top-color: #eb8f00 !important;',
    '}',

    /* --- Dropdown menu active/hover --- */
    '.dropdown-item.active, .dropdown-item:active {',
    '  background-color: #004337 !important;',
    '  color: #ffffff !important;',
    '}',
    '.dropdown-item:hover, .dropdown-item:focus {',
    '  background-color: rgba(0, 67, 55, 0.06) !important;',
    '  color: #004337 !important;',
    '}',

    /* --- Pgn icon button --- */
    '.pgn__icon-button:hover, .pgn__icon-button:focus {',
    '  color: #eb8f00 !important;',
    '}',

    /* --- Accessible focus ring (keyboard nav) --- */
    '*:focus-visible {',
    '  outline: 2px solid #eb8f00 !important;',
    '  outline-offset: 2px !important;',
    '}',

    /* --- bg-primary utility → TBA dark green --- */
    '.bg-primary { background-color: #004337 !important; }',

    /* --- Footer → TBA dark green, logo left, links centered (responsive) --- */
    'footer, footer.d-flex {',
    '  background-color: #004337 !important;',
    '  color: #ffffff !important;',
    '  border-top: none !important;',
    '  display: flex !important;',
    '  flex-direction: row !important;',
    '  align-items: center !important;',
    '  flex-wrap: nowrap !important;',
    '  position: relative !important;',
    '  min-height: 70px !important;',
    '}',
    'footer.d-flex > a:first-child,',
    'footer.d-flex > img:first-child {',
    '  flex: 0 0 auto !important;',
    '}',
    /* top-footer nav: absolutely centered links */
    'footer .top-footer {',
    '  list-style: none !important;',
    '  margin: 0 !important;',
    '  padding: 0 !important;',
    '  display: flex !important;',
    '  flex-direction: row !important;',
    '  flex-wrap: nowrap !important;',
    '  gap: 0.75rem !important;',
    '  align-items: center !important;',
    '  position: absolute !important;',
    '  left: 50% !important;',
    '  top: 50% !important;',
    '  transform: translate(-50%, -50%) !important;',
    '}',
    'footer .top-footer li {',
    '  white-space: nowrap !important;',
    '  color: rgba(255,255,255,0.4) !important;',
    '  font-size: 0.875rem !important;',
    '}',
    'footer .top-footer a {',
    '  color: #eb8f00 !important;',
    '  font: inherit;',
    '  text-decoration: none !important;',
    '  transition: all 0.1s linear 0s;',
    '  white-space: nowrap !important;',
    '}',
    'footer .top-footer a:hover { color: #FFC745 !important; }',
    /* Mobile: empilé verticalement */
    '@media (max-width: 768px) {',
    '  footer.d-flex {',
    '    flex-direction: column !important;',
    '    align-items: center !important;',
    '    gap: 1rem !important;',
    '    padding: 1rem !important;',
    '  }',
    '  footer .top-footer {',
    '    position: static !important;',
    '    transform: none !important;',
    '    flex-direction: column !important;',
    '    gap: 0.5rem !important;',
    '    align-items: center !important;',
    '  }',
    '  footer .top-footer li:not(:has(a)) {',
    '    display: none !important;',
    '  }',
    '}',
    /* Legacy single-link compat */
    'footer a:not(.top-footer a):not(.top-footer *):not([class*="logo"]) {',
    '  color: #FFC745 !important;',
    '}',

    /* --- Paragon accent-a text colour override (default is cyan) --- */
    '.text-accent-a { color: #eb8f00 !important; }',
    /* On dark green backgrounds (banners, headers) use light amber */
    '[class*="bg-primary"] .text-accent-a,',
    '.banner__image .text-accent-a,',
    '.col-md-9.bg-primary-400 .text-accent-a,',
    '.col-md-9.bg-primary-500 .text-accent-a {',
    '  color: #FFC745 !important;',
    '}',
  ].join('\n');

  if (document.getElementById('tba-mfe-global-styles')) return;
  var style = document.createElement('style');
  style.id = 'tba-mfe-global-styles';
  style.textContent = TBA_GLOBAL_CSS;
  document.head.appendChild(style);
  console.log('[TBA] Global MFE styles injected');
})();

// TBA — Inject top-footer navigation (Contact, TOS, Charte) into every MFE footer
(function() {
  function injectTopFooter() {
    var footer = document.querySelector('footer');
    if (!footer) return;
    if (footer.querySelector('.top-footer')) return;
    var ul = document.createElement('ul');
    ul.className = 'top-footer';
    ul.innerHTML = ''
      + '<li><a href="/contact">Contact</a></li>'
      + '<li>|</li>'
      + '<li><a href="/tos">Conditions générales d\'utilisation</a></li>'
      + '<li>|</li>'
      + '<li><a href="/honor">Charte utilisateurs</a></li>';
    footer.appendChild(ul);
  }
  function start() {
    if (document.body) {
      injectTopFooter();
      new MutationObserver(injectTopFooter).observe(document.body, { childList: true, subtree: true });
    } else { setTimeout(start, 50); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

// TBA — Fix logo/link protocol to match current page (http vs https)
(function() {
  var DOMAIN = 'platform.tunisbourse-academy.com';
  function fixProtocol() {
    var proto = window.location.protocol; // 'http:' or 'https:'
    document.querySelectorAll('img[src*="' + DOMAIN + '"]').forEach(function(img) {
      var src = img.getAttribute('src') || '';
      var fixed = src.replace(/^https?:/, proto);
      if (fixed !== src) img.setAttribute('src', fixed);
    });
    document.querySelectorAll('a[href*="' + DOMAIN + '"]').forEach(function(a) {
      var href = a.getAttribute('href') || '';
      var fixed = href.replace(/^https?:/, proto);
      if (fixed !== href) a.setAttribute('href', fixed);
    });
  }
  var _obs = new MutationObserver(fixProtocol);
  function start() {
    if (document.body) {
      _obs.observe(document.body, { childList: true, subtree: true });
      fixProtocol();
    } else { setTimeout(start, 50); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
    if (process.env.APP_ID == 'admin-console') {
    }
    if (process.env.APP_ID == 'authn') {// TBA - Authn MFE : CSS design system + injection champ Profil
// CSS : transforme l'apparence de la page login/register (panel vert, carte blanche, champs amber)
// Profil : MutationObserver + patch fetch/XHR pour inclure tba_profil dans le POST registration

// ============================================================
// BLOC 1 — CSS spécifique authn MFE (login + register)
// ============================================================
(function() {
  var AUTHN_CSS = [
    '/* ========================================================',
    '   TBA Authn MFE — Login & Register pages',
    '   Left panel : dark green gradient',
    '   Right panel: white card with shadow',
    '   ======================================================== */',

    /* --- Logo (left panel) — logo-investia.png, width 15rem --- */
    'img.logo, img.logo.position-absolute {',
    '  width: 15rem !important;',
    '  height: auto !important;',
    '  max-width: 15rem !important;',
    '}',

    /* --- SVG decorative elements — TBA dark green fill --- */
    '.large-screen-svg-primary,',
    '.medium-screen-svg-primary {',
    '  fill: #004337 !important;',
    '  background-color: #f5f7f6 !important;',
    '}',

    /* --- Left panel (banner / image layout) --- */
    /* Override amber bg-primary-500 → TBA dark green           */
    /* background-image: none overrides the inline style URL    */
    '.banner__image,',
    '.banner__image.large-layout,',
    '.banner__image.medium-layout {',
    '  background-color: #004337 !important;',
    '  background-image:',
    '    radial-gradient(circle at 15% 85%, rgba(235,143,0,0.10) 0%, transparent 45%),',
    '    radial-gradient(circle at 85% 15%, rgba(255,199,69,0.07) 0%, transparent 45%) !important;',
    '  position: relative !important;',
    '}',

    /* Decorative ring in bottom-right corner */
    '.banner__image::after {',
    '  content: "" ;',
    '  position: absolute;',
    '  bottom: -90px; right: -90px;',
    '  width: 320px; height: 320px;',
    '  border-radius: 50%;',
    '  border: 1px solid rgba(235,143,0,0.18);',
    '  pointer-events: none;',
    '}',

    /* Left panel text colours */
    '.banner__image .text-light-500,',
    '.banner__image span.text-light-500 {',
    '  color: #ffffff !important;',
    '}',
    '.banner__image .text-warning-300,',
    '.banner__image span.text-warning-300 {',
    '  color: #FFC745 !important;',
    '}',
    /* Accent-a text inside banner */
    '.banner__image .text-accent-a { color: #FFC745 !important; }',

    /* Default layout left column (non-image layout) */
    '.col-md-9.bg-primary-400 {',
    '  background-color: #004337 !important;',
    '}',
    /* Generic bg-primary-400 on authn pages → dark green */
    '.bg-primary-400 {',
    '  background-color: #004337 !important;',
    '}',

    /* SVG triangle separator between left panel and form */
    '.large-screen-svg-primary,',
    '.medium-screen-svg-primary {',
    '  fill: #004337 !important;',
    '}',

    /* --- Top coloured stripes (small / medium screens) --- */
    '.small-screen-top-stripe {',
    '  background-image: linear-gradient(',
    '    102.02deg,',
    '    #002e26, #002e26 20%,',
    '    #004337 20%',
    '  ) !important;',
    '}',
    '.medium-screen-top-stripe {',
    '  background-image: linear-gradient(',
    '    102.02deg,',
    '    #002e26     0%,',
    '    #002e26    10%,',
    '    #004337    10%,',
    '    #004337    70%,',
    '    #eb8f00    70%,',
    '    #eb8f00   100%',
    '  ) !important;',
    '}',
    '.extra-large-screen-top-stripe {',
    '  background-image: linear-gradient(',
    '    102.02deg,',
    '    #002e26     0%,',
    '    #002e26    10%,',
    '    #004337    10%,',
    '    #004337    45%,',
    '    #eb8f00    45%,',
    '    #eb8f00    65%,',
    '    #FFC745    65%',
    '  ) !important;',
    '}',

    /* --- Page background: light gray everywhere on authn pages --- */
    'body, html {',
    '  background-color: #f5f7f6 !important;',
    '}',
    /* The col-md-3 that wraps the SVG separator has bg-white class — override */
    '.col-md-3.bg-white {',
    '  background-color: #f5f7f6 !important;',
    '}',
    /* Right side outer wrapper */
    '.content, body .content {',
    '  background-color: #f5f7f6 !important;',
    '}',

    /* --- Form card (white, shadow, rounded) --- */
    'body .main-content {',
    '  background: #ffffff !important;',
    '  border-radius: 12px !important;',
    '  box-shadow: 0 4px 32px rgba(0,0,0,0.08), 0 1px 4px rgba(0,0,0,0.04) !important;',
    '  border: 1px solid #f0f0f0 !important;',
    '  padding: 2rem 2.5rem !important;',
    '}',
    'body .welcome-page-content {',
    '  background: #ffffff !important;',
    '  border-radius: 12px !important;',
    '  box-shadow: 0 4px 32px rgba(0,0,0,0.08) !important;',
    '}',

    /* --- Page headings inside the form --- */
    '.mw-xs h2, .mw-xs .h2,',
    '.main-content h2, .main-content .h2 {',
    '  color: #004337 !important;',
    '  font-weight: 700 !important;',
    '}',

    /* --- Forgot password link --- */
    '#forgot-password {',
    '  color: #eb8f00 !important;',
    '  font-weight: 500 !important;',
    '}',
    '#forgot-password:hover, #forgot-password:focus {',
    '  color: #d47e00 !important;',
    '  text-decoration: underline !important;',
    '}',

    /* --- Tab toggle (Sign in / Register) --- */
    '.logistration-button {',
    '  color: #6b7280 !important;',
    '  font-weight: 400 !important;',
    '}',
    '.logistration-button:hover {',
    '  color: #004337 !important;',
    '}',

    /* --- Login submit button --- */
    '.login-button-width, .register-button {',
    '  min-width: 10rem !important;',
    '}',

    /* --- Social login buttons --- */
    '.btn-social {',
    '  border-radius: 6px !important;',
    '  border-width: 1.5px !important;',
    '  font-size: 0.875rem !important;',
    '}',

    /* --- TBA Profil field (injected dropdown) --- */
    '#tba-profil-wrapper {',
    '  margin-bottom: 1.5rem;',
    '}',
    '#tba-profil-wrapper select {',
    '  border-radius: 6px !important;',
    '  border: 1px solid #d1d5db !important;',
    '  height: 2.75rem !important;',
    '  font-size: 0.9375rem !important;',
    '  padding: 0 0.75rem !important;',
    '  width: 100% !important;',
    '  transition: border-color 0.15s ease, box-shadow 0.15s ease !important;',
    '}',
    '#tba-profil-wrapper select:focus {',
    '  border-color: #eb8f00 !important;',
    '  box-shadow: 0 0 0 3px rgba(235,143,0,0.18) !important;',
    '  outline: none !important;',
    '}',
    '#tba-profil-wrapper .pgn__form-label {',
    '  font-weight: 500 !important;',
    '  color: #374151 !important;',
    '  margin-bottom: 0.375rem !important;',
    '}',
    '#tba_profil_error {',
    '  font-size: 0.8125rem !important;',
    '  margin-top: 0.25rem !important;',
    '}',

    /* --- Register page — "Already have account?" link --- */
    '.already-have-account a,',
    'a[href*="login"] { color: #eb8f00 !important; font-weight: 600 !important; }',
  ].join('\n');

  if (document.getElementById('tba-authn-styles')) return;
  var style = document.createElement('style');
  style.id = 'tba-authn-styles';
  style.textContent = AUTHN_CSS;
  document.head.appendChild(style);
  console.log('[TBA] Authn MFE styles injected');
})();

// ============================================================
// BLOC 2 — Injection du champ "Profil" dans le formulaire d'inscription
// ============================================================

(function() {
  const TBA_PROFIL_CHOICES = [
    ['', '-- Sélectionnez votre profil --'],
    ['actionnaire', 'Actionnaire'],
    ['cadre_dirigeant', 'Cadre dirigeant'],
    ['collegien_lyceen', 'Collégien / Lycéen'],
    ['ecolier', 'Écolier'],
    ['etudiant', 'Étudiant'],
    ['fonctionnaire', 'Fonctionnaire'],
    ['salarie', 'Salarié'],
    ['profession_liberale', 'Profession libérale'],
    ['investisseur_particulier', 'Investisseur particulier'],
    ['journaliste', 'Journaliste'],
  ];

  // Keep tba_profil value in a persistent variable updated on select change
  // so it's available even after React re-renders remove the DOM element
  window.__tbaProfilValue = window.__tbaProfilValue || '';

  // 1a. Patch window.fetch pour injecter tba_profil (+ terms_of_service pour v2) dans le POST registration
  if (!window.__tbaPatchApplied) {
    window.__tbaPatchApplied = true;
    const _origFetch = window.fetch.bind(window);
    window.fetch = function(url, options) {
      if (
        options &&
        typeof options.method === 'string' &&
        options.method.toUpperCase() === 'POST' &&
        typeof url === 'string' &&
        (url.includes('/api/user/v1/account/registration/') || url.includes('/api/user/v2/account/registration/'))
      ) {
        const select = document.getElementById('tba_profil');
        const value = (select && select.value) ? select.value : window.__tbaProfilValue;
        const isV2 = url.includes('/api/user/v2/account/registration/');
        try {
          if (options.body instanceof URLSearchParams) {
            if (value) options.body.set('tba_profil', value);
            if (isV2) options.body.set('terms_of_service', 'true');
          } else if (typeof options.body === 'string') {
            const params = new URLSearchParams(options.body);
            if (value) params.set('tba_profil', value);
            if (isV2) params.set('terms_of_service', 'true');
            options.body = params.toString();
          } else if (options.body instanceof FormData) {
            if (value) options.body.set('tba_profil', value);
            if (isV2) options.body.set('terms_of_service', 'true');
          }
          if (value) console.log('[TBA] tba_profil="' + value + '" injecte dans POST /registration/ (fetch)');
        } catch (e) {
          console.warn('[TBA] Impossible de patcher le body (fetch):', e);
        }
      }
      return _origFetch(url, options);
    };
  }

  // 1b. Patch XMLHttpRequest pour intercepter axios (qui utilise XHR, pas window.fetch)
  if (!window.__tbaXhrPatchApplied) {
    window.__tbaXhrPatchApplied = true;
    var _origOpen = XMLHttpRequest.prototype.open;
    var _origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(method, url) {
      this._tbaMethod = method;
      this._tbaUrl = url;
      return _origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function(body) {
      var url = this._tbaUrl || '';
      var method = (this._tbaMethod || '').toUpperCase();
      if (
        method === 'POST' &&
        typeof url === 'string' &&
        (url.includes('/api/user/v1/account/registration/') || url.includes('/api/user/v2/account/registration/'))
      ) {
        var select = document.getElementById('tba_profil');
        var value = (select && select.value) ? select.value : window.__tbaProfilValue;
        var isV2 = url.includes('/api/user/v2/account/registration/');
        try {
          if (body instanceof URLSearchParams) {
            if (value) body.set('tba_profil', value);
            if (isV2) body.set('terms_of_service', 'true');
          } else if (typeof body === 'string') {
            var params = new URLSearchParams(body);
            if (value) params.set('tba_profil', value);
            if (isV2) params.set('terms_of_service', 'true');
            body = params.toString();
          } else if (body instanceof FormData) {
            if (value) body.set('tba_profil', value);
            if (isV2) body.set('terms_of_service', 'true');
          }
          if (value) console.log('[TBA] tba_profil="' + value + '" injecte dans POST /registration/ (xhr)');
        } catch (e) {
          console.warn('[TBA] Impossible de patcher le body (xhr):', e);
        }
      }
      return _origSend.call(this, body);
    };
  }

  // 2. Construction du champ DOM
  function buildProfilField() {
    const wrapper = document.createElement('div');
    wrapper.className = 'pgn__form-group mb-4';
    wrapper.id = 'tba-profil-wrapper';

    const label = document.createElement('label');
    label.htmlFor = 'tba_profil';
    label.className = 'pgn__form-label d-block mb-1';
    label.textContent = 'Profil';
    const required = document.createElement('span');
    required.textContent = ' *';
    required.className = 'text-danger';
    required.setAttribute('aria-hidden', 'true');
    label.appendChild(required);

    const select = document.createElement('select');
    select.id = 'tba_profil';
    select.name = 'tba_profil';
    select.required = true;
    select.className = 'pgn__form-control form-control';
    select.style.cssText = 'width:100%;height:calc(2.5rem + 2px);border:1px solid #ced4da;border-radius:.3rem;padding:.375rem .75rem;font-size:1rem;';

    TBA_PROFIL_CHOICES.forEach(function(item) {
      var opt = document.createElement('option');
      opt.value = item[0];
      opt.textContent = item[1];
      select.appendChild(opt);
    });

    const errorDiv = document.createElement('div');
    errorDiv.id = 'tba_profil_error';
    errorDiv.className = 'pgn__form-text text-danger';
    errorDiv.style.display = 'none';
    errorDiv.setAttribute('role', 'alert');
    errorDiv.textContent = 'Veuillez selectionner votre profil.';

    select.addEventListener('invalid', function(e) {
      e.preventDefault();
      errorDiv.style.display = 'block';
      select.style.borderColor = '#c00';
    });
    select.addEventListener('change', function() {
      errorDiv.style.display = 'none';
      select.style.borderColor = '';
      window.__tbaProfilValue = select.value;
    });

    wrapper.appendChild(label);
    wrapper.appendChild(select);
    wrapper.appendChild(errorDiv);
    return wrapper;
  }

  // 3. Injection dans le formulaire
  function injectField() {
    if (!window.location.pathname.includes('/register')) return false;

    var submitBtn = (
      document.querySelector('[data-testid="register-user"]') ||
      document.querySelector('button[type="submit"].btn-brand') ||
      document.querySelector('button[type="submit"].pgn__stateful-btn') ||
      document.querySelector('.registration-request-btn') ||
      document.querySelector('form button[type="submit"]')
    );

    if (!submitBtn) return false;

    // Determine where to insert: before the button's form-group wrapper if it
    // has one, otherwise directly before the button itself (inside the form).
    var btnGroup = submitBtn.closest('.form-group, .pgn__form-group');
    var insertParent = btnGroup ? btnGroup.parentNode : submitBtn.parentNode;
    var insertBefore = btnGroup || submitBtn;
    if (!insertParent) return false;

    var existing = document.getElementById('tba-profil-wrapper');
    if (existing) {
      // Already in the correct last position — nothing to do
      if (existing.parentNode === insertParent && existing.nextElementSibling === insertBefore) return true;
      // Wrong position — move to last inside the form, just before the button
      insertParent.insertBefore(existing, insertBefore);
      return true;
    }

    // Field not in DOM yet — inject it in last position inside the form
    var field = buildProfilField();
    // Restore previously selected value if any
    if (window.__tbaProfilValue) {
      var sel = field.querySelector('select');
      if (sel) sel.value = window.__tbaProfilValue;
    }
    insertParent.insertBefore(field, insertBefore);
    console.log('[TBA] Champ tba_profil injecte avec succes');
    return true;
  }

  // 4. MutationObserver + navigation SPA
  var observer = new MutationObserver(function() {
    if (!window.location.pathname.includes('/register')) return;
    // Always call injectField so it can reposition the field if React re-rendered
    injectField();
  });

  function startObserver() {
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
      injectField();
    } else {
      setTimeout(startObserver, 50);
    }
  }

  var _lastPath = window.location.pathname;
  setInterval(function() {
    if (window.location.pathname !== _lastPath) {
      _lastPath = window.location.pathname;
      if (window.location.pathname.includes('/register')) injectField();
    }
  }, 300);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();

// ============================================================
// BLOC 3 — Fix : espace manquant avant les liens mailto:
// Bug de traduction FR du MFE authn :
//   "...à l'adressecontact@tunisbourse-academy.com" (sans espace)
// On insère un espace dans le text-node qui précède le <a mailto:>
// si ce text-node ne se termine pas déjà par un espace.
// ============================================================
(function() {
  function fixMailtoSpacing() {
    var links = document.querySelectorAll('a[href^="mailto:"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var prev = a.previousSibling;
      if (prev && prev.nodeType === 3 && prev.nodeValue && /\S$/.test(prev.nodeValue)) {
        prev.nodeValue = prev.nodeValue + ' ';
      }
    }
  }
  var obs = new MutationObserver(fixMailtoSpacing);
  function start() {
    if (document.body) {
      obs.observe(document.body, { childList: true, subtree: true });
      fixMailtoSpacing();
    } else {
      setTimeout(start, 50);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
    }
    if (process.env.APP_ID == 'authoring') {
    }
    if (process.env.APP_ID == 'account') {// TBA — Account MFE CSS + champ Profil
// CSS : aligne le MFE compte (account settings) avec la charte TBA
(function() {
  var ACCOUNT_CSS = [
    '/* TBA Account MFE — Settings page */',

    /* Section headings */
    '.account-section .section-heading, h2.section-heading {',
    '  color: #004337 !important;',
    '  font-weight: 700 !important;',
    '  border-bottom: 2px solid #eb8f00 !important;',
    '  padding-bottom: 0.5rem !important;',
    '  margin-bottom: 1.25rem !important;',
    '}',

    /* Save button inside account section */
    '#profile button {',
    '  background-color: #004337 !important;',
    '  border-color: #004337 !important;',
    '  color: #ffffff !important;',
    '  border-radius: 6px !important;',
    '  font-weight: 600 !important;',
    '  padding: 0.5rem 1.5rem !important;',
    '  transition: background-color 0.15s ease !important;',
    '}',
    '#profile button:hover {',
    '  background-color: #eb8f00 !important;',
    '  border-color: #eb8f00 !important;',
    '}',

    /* Profil select in account settings */
    '#profile select {',
    '  border-radius: 6px !important;',
    '  border: 1px solid #d1d5db !important;',
    '  font-size: 0.9375rem !important;',
    '}',
    '#profile select:focus {',
    '  border-color: #eb8f00 !important;',
    '  box-shadow: 0 0 0 3px rgba(235,143,0,0.18) !important;',
    '  outline: none !important;',
    '}',

    /* Alert links */
    '.account-section .alert a { color: #eb8f00 !important; }',
  ].join('\n');

  if (document.getElementById('tba-account-styles')) return;
  var st = document.createElement('style');
  st.id = 'tba-account-styles';
  st.textContent = ACCOUNT_CSS;
  document.head.appendChild(st);
  console.log('[TBA] Account MFE styles injected');
})();

// TBA - Affichage et modification du champ "Profil" dans les paramètres du compte
(function() {
  const TBA_PROFIL_CHOICES = [
    ['actionnaire',              'Actionnaire'],
    ['cadre_dirigeant',          'Cadre dirigeant'],
    ['collegien_lyceen',         'Collégien / Lycéen'],
    ['ecolier',                  'Écolier'],
    ['etudiant',                 'Étudiant'],
    ['fonctionnaire',            'Fonctionnaire'],
    ['salarie',                  'Salarié'],
    ['profession_liberale',      'Profession libérale'],
    ['investisseur_particulier', 'Investisseur particulier'],
    ['journaliste',              'Journaliste'],
  ];

  function getLmsBase() {
    return window.location.origin.replace('apps.', '');
  }

  function fetchProfilValue(username, callback) {
    fetch(getLmsBase() + '/api/user/v1/accounts/' + username, {
      credentials: 'include',
      headers: { 'Accept': 'application/json' }
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var ext = data.extended_profile || [];
      var field = ext.find(function(f) { return f.field_name === 'tba_profil'; });
      callback(field ? field.field_value : '', data.username || '');
    })
    .catch(function() { callback('', ''); });
  }

  function saveProfilValue(username, value, callback) {
    var csrfToken = (document.cookie.split('; ')
      .find(function(c) { return c.startsWith('csrftoken='); }) || '').split('=')[1] || '';
    fetch(getLmsBase() + '/api/user/v1/accounts/' + username, {
      method: 'PATCH',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/merge-patch+json',
        'Accept': 'application/json',
        'X-CSRFToken': csrfToken,
      },
      body: JSON.stringify({
        extended_profile: [{ field_name: 'tba_profil', field_value: value }]
      })
    })
    .then(function(r) { callback(r.ok ? null : 'Erreur ' + r.status); })
    .catch(function(e) { callback(String(e)); });
  }

  function buildProfilSection(username, currentValue) {
    var section = document.createElement('div');
    section.id = 'profile';
    section.className = 'account-section pt-3 mb-5';

    var heading = document.createElement('h2');
    heading.className = 'section-heading h4 mb-3';
    heading.textContent = 'Profil';
    section.appendChild(heading);

    var row = document.createElement('div');
    row.style.cssText = 'display:flex;align-items:center;gap:1rem;flex-wrap:wrap;';

    var select = document.createElement('select');
    select.style.cssText = 'flex:1;min-width:220px;height:2.5rem;border:1px solid #ced4da;border-radius:.3rem;padding:.375rem .75rem;font-size:1rem;';

    var emptyOpt = document.createElement('option');
    emptyOpt.value = '';
    emptyOpt.textContent = '-- Sélectionnez votre profil --';
    select.appendChild(emptyOpt);
    TBA_PROFIL_CHOICES.forEach(function(c) {
      var opt = document.createElement('option');
      opt.value = c[0];
      opt.textContent = c[1];
      if (c[0] === currentValue) opt.selected = true;
      select.appendChild(opt);
    });

    var btn = document.createElement('button');
    btn.textContent = 'Enregistrer';
    btn.style.cssText = 'padding:.375rem 1.25rem;background:#0d6efd;color:#fff;border:none;border-radius:.3rem;cursor:pointer;font-size:1rem;white-space:nowrap;';

    var msg = document.createElement('span');
    msg.style.cssText = 'font-size:.875rem;';

    btn.addEventListener('click', function() {
      btn.disabled = true;
      btn.textContent = '...';
      saveProfilValue(username, select.value, function(err) {
        btn.disabled = false;
        btn.textContent = 'Enregistrer';
        if (err) {
          msg.style.color = '#c00';
          msg.textContent = err;
        } else {
          msg.style.color = '#198754';
          msg.textContent = '✓ Sauvegardé';
          setTimeout(function() { msg.textContent = ''; }, 3000);
        }
      });
    });

    row.appendChild(select);
    row.appendChild(btn);
    row.appendChild(msg);
    section.appendChild(row);
    return section;
  }

  function injectAccountProfilField() {
    if (!window.location.pathname.startsWith('/account')) return;
    if (document.getElementById('profile')) return;

    // Find all account-section divs; append after the last one
    var sections = document.querySelectorAll('.account-section');
    if (!sections.length) return;
    var lastSection = sections[sections.length - 1];
    var container = lastSection.parentNode;
    if (!container) return;

    // Get the logged-in user from the account API /me
    fetch(getLmsBase() + '/api/user/v1/me', {
      credentials: 'include',
      headers: { 'Accept': 'application/json' }
    })
    .then(function(r) { return r.json(); })
    .then(function(me) {
      var username = me.username;
      if (!username) return;
      fetchProfilValue(username, function(value) {
        if (document.getElementById('profile')) return;
        var widget = buildProfilSection(username, value);
        container.insertBefore(widget, lastSection.nextSibling);
        console.log('[TBA] Section Profil injectée dans account settings');

        // If the user landed on /account/#profile (e.g. clicked
        // "Renseigner mon profil" from the /courses prompt), the browser
        // already gave up scrolling because the widget didn't exist when the
        // URL was parsed.  We re-trigger the scroll now that it's in the DOM.
        if (window.location.hash === '#profile') {
          setTimeout(function() {
            var el = document.getElementById('profile');
            if (!el) return;
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            // Brief highlight to draw attention
            var origBg = el.style.backgroundColor;
            el.style.transition = 'background-color 0.6s ease';
            el.style.backgroundColor = 'rgba(255, 199, 69, 0.25)';
            setTimeout(function() { el.style.backgroundColor = origBg; }, 1500);
            // Focus the <select> so the user can change it via keyboard too
            var select = el.querySelector('select');
            if (select) {
              try { select.focus({ preventScroll: true }); } catch(_) { select.focus(); }
            }
          }, 50);
        }
      });
    })
    .catch(function() {});
  }

  // Inject "Profil" link in sidebar after "Delete My Account / Supprimer mon Compte".
  // Language-agnostic: prefer matching by href anchor (#delete-account), fall
  // back to text matching in both English and French (since the sidebar may be
  // translated by our FR injection).
  function injectSidebarProfileLink() {
    if (document.getElementById('tba-sidebar-profile-link')) return;

    // 1) Prefer anchor-based selector (works regardless of UI language)
    var deleteLink = document.querySelector('a[href$="#delete-account"]')
                  || document.querySelector('a[href*="delete"]');

    // 2) Fall back to text matching (FR or EN)
    if (!deleteLink) {
      var DELETE_LABELS = [
        'Delete My Account',
        'Supprimer mon Compte',
        'Supprimer Mon Compte',
        'Supprimer mon compte',
      ];
      deleteLink = Array.from(document.querySelectorAll('a')).find(function(a) {
        var t = (a.textContent || '').trim();
        return DELETE_LABELS.indexOf(t) !== -1;
      });
    }
    if (!deleteLink) return;

    var ul = deleteLink.closest('ul');
    if (!ul) return;
    var li = document.createElement('li');
    // Reuse the host <li>'s class if available, otherwise fall back to <a>'s
    var siblingLi = deleteLink.closest('li');
    if (siblingLi && siblingLi.className) li.className = siblingLi.className;

    var a = document.createElement('a');
    a.id = 'tba-sidebar-profile-link';
    a.href = '/account/#profile';
    a.textContent = 'Profil';
    a.className = deleteLink.className;
    li.appendChild(a);
    ul.appendChild(li);
    console.log('[TBA] Sidebar Profil link injected');
  }

  var _observer = new MutationObserver(function() {
    if (window.location.pathname.startsWith('/account')) {
      injectAccountProfilField();
      injectSidebarProfileLink();
    }
  });

  function start() {
    if (document.body) {
      _observer.observe(document.body, { childList: true, subtree: true });
      injectAccountProfilField();
      injectSidebarProfileLink();
    } else {
      setTimeout(start, 50);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
    }
    if (process.env.APP_ID == 'communications') {
    }
    if (process.env.APP_ID == 'discussions') {
    }
    if (process.env.APP_ID == 'gradebook') {
    }
    if (process.env.APP_ID == 'learner-dashboard') {// TBA — Learner Dashboard MFE CSS
// Améliore les cartes de cours, la navigation, les barres de progression
// et le bandeau d'accueil du tableau de bord apprenant.
(function() {
  var DASHBOARD_CSS = [
    '/* ========================================================',
    '   TBA Learner Dashboard MFE',
    '   Course cards, tabs, progress, empty states',
    '   ======================================================== */',

    /* --- Course cards: hover lift (z-index keeps dropdown above challenge widget) --- */
    '.pgn__card:hover, .card:hover {',
    '  transform: translateY(-3px) !important;',
    '  box-shadow: 0 8px 28px rgba(0,0,0,0.10) !important;',
    '  position: relative !important;',
    '  z-index: 20 !important;',
    '}',
    /* Ensure open dropdown inside a hovered card also surfaces above the widget */
    '.pgn__card .dropdown-menu.show,',
    '.card .dropdown-menu.show {',
    '  z-index: 30 !important;',
    '}',

    /* Dropdown menu hover tint — dashboard only */
    '.dropdown-menu.show:hover,',
    '.dropdown-menu.show:focus,',
    '.dropdown-menu.show .dropdown-item:hover,',
    '.dropdown-menu.show .dropdown-item:focus {',
    '  background-color: rgb(240, 244, 243) !important;',
    '  color: #004337 !important;',
    '}',

    /* Course card image: fixed height, cover */
    '.pgn__card-image-cap img,',
    '.card-img-top {',
    '  height: 160px !important;',
    '  object-fit: cover !important;',
    '}',

    /* Course card footer CTA */
    '.pgn__card-footer,',
    '.card-footer {',
    '  background: transparent !important;',
    '  border-top: 1px solid #f0f0f0 !important;',
    '  padding: 0.75rem 1rem !important;',
    '}',

    /* --- Dashboard welcome banner --- */
    '.banner, .hero-banner,',
    '.learner-dashboard__header,',
    '[class*="WelcomeBanner"] {',
    '  background: linear-gradient(135deg, #004337 0%, #002e26 100%) !important;',
    '  color: #ffffff !important;',
    '  border-bottom: 3px solid #FFC745 !important;',
    '}',
    '.banner h1, .banner h2,',
    '.hero-banner h1, .hero-banner h2,',
    '[class*="WelcomeBanner"] h1, [class*="WelcomeBanner"] h2 {',
    '  color: #ffffff !important;',
    '}',

    /* --- Tab navigation (My courses / Programs / Recommended) --- */
    '.learner-tabs .nav-tabs,',
    '[class*="TabBar"] .nav-tabs,',
    '.dashboard-tabs .nav-tabs {',
    '  border-bottom: 2px solid #e5e7eb !important;',
    '}',

    /* --- Sidebar / filter active item --- */
    '.sidebar .nav-link.active,',
    '.filter-bar .active,',
    '[class*="Sidebar"] .nav-link.active {',
    '  color: #004337 !important;',
    '  border-left: 3px solid #eb8f00 !important;',
    '  font-weight: 600 !important;',
    '  background-color: rgba(0,67,55,0.04) !important;',
    '}',

    /* --- Empty state (no enrolled courses) --- */
    '.no-courses-heading,',
    '[class*="EmptyState"] h2,',
    '[class*="EmptyState"] h3 {',
    '  color: #004337 !important;',
    '}',

    /* --- Course progress bar inside card --- */
    '.course-progress .progress-bar,',
    '.pgn__card .progress-bar {',
    '  background-color: #eb8f00 !important;',
    '}',

    /* --- "Resume Course" / "Start Course" buttons --- */
    '.resume-btn, [class*="resume"],',
    'a.resume-course-btn {',
    '  background-color: #004337 !important;',
    '  border-color: #004337 !important;',
    '  color: #ffffff !important;',
    '  border-radius: 6px !important;',
    '  font-weight: 600 !important;',
    '}',
    '.resume-btn:hover, [class*="resume"]:hover {',
    '  background-color: #002e26 !important;',
    '  border-color: #002e26 !important;',
    '  color: #ffffff !important;',
    '}',

    /* --- Course status badge (Active / Archived / Upcoming) --- */
    '.course-status-badge.active,',
    '[class*="CourseStatusBadge"].active {',
    '  background-color: rgba(0,67,55,0.1) !important;',
    '  color: #004337 !important;',
    '  border-radius: 4px !important;',
    '}',

    /* --- Pagination buttons --- */
    '.page-link:hover {',
    '  color: #004337 !important;',
    '  background-color: rgba(0,67,55,0.06) !important;',
    '}',
    '.page-item.active .page-link {',
    '  background-color: #004337 !important;',
    '  border-color: #004337 !important;',
    '}',

    /* --- Dashboard main layout spacing --- */
    '.learner-dashboard,',
    '[class*="Dashboard"] > main {',
    '  background-color: #f8f9fa !important;',
    '  min-height: 100vh !important;',
    '}',

    /* --- "À la recherche d'un nouveau défi ?" widget --- */
    /* Outer card: dark green to eliminate white bleed */
    '.sidebar-column .pgn__card.horizontal {',
    '  background-color: #004337 !important;',
    '  box-shadow: 0 2px 16px rgba(0,0,0,0.10) !important;',
    '}',
    /* Right panel: dark green bg, white text, amber link */
    '.sidebar-column .pgn__card.horizontal .pgn__card-body {',
    '  background-color: #004337 !important;',
    '  border-radius: 0 8px 8px 0 !important;',
    '}',
    '.sidebar-column .pgn__card.horizontal .pgn__card-body * {',
    '  color: #ffffff !important;',
    '}',
    '.sidebar-column .pgn__card.horizontal .pgn__card-body a,',
    '.sidebar-column .pgn__card.horizontal .pgn__card-body a * {',
    '  color: #eb8f00 !important;',
    '}',
    '.sidebar-column .pgn__card.horizontal .pgn__card-body a:hover,',
    '.sidebar-column .pgn__card.horizontal .pgn__card-body a:hover * {',
    '  color: #FFC745 !important;',
    '}',
  ].join('\n');

  if (document.getElementById('tba-dashboard-styles')) return;
  var style = document.createElement('style');
  style.id = 'tba-dashboard-styles';
  style.textContent = DASHBOARD_CSS;
  document.head.appendChild(style);
  console.log('[TBA] Learner Dashboard styles injected');
})();
    }
    if (process.env.APP_ID == 'learning') {// TBA — Learning MFE CSS
// Améliore : header du cours, sidebar de navigation, progression,
// icônes d'unité, boutons next/previous, séquence de cours.
(function() {
  var LEARNING_CSS = [
    '/* ========================================================',
    '   TBA Learning MFE — Course delivery',
    '   Header, sidebar, sequence nav, unit icons, progress',
    '   ======================================================== */',

    /* --- Learning MFE header --- */
    '.learning-header,',
    'header.learning-header,',
    '[class*="LearningHeader"] {',
    '  background-color: #004337 !important;',
    '  border-bottom: 2px solid #FFC745 !important;',
    '}',
    '.learning-header a, .learning-header button,',
    '.learning-header .btn {',
    '  color: #ffffff !important;',
    '}',
    '.learning-header a:hover, .learning-header button:hover {',
    '  color: #FFC745 !important;',
    '}',
    /* Course title in header */
    '.learning-header .course-title,',
    '.learning-header h1, .learning-header h2 {',
    '  color: #ffffff !important;',
    '}',
    /* Breadcrumb org/run label (e.g. "OpenedX DemoX") → amber, only in header */
    '.learning-header span.d-block.small,',
    '.learning-header .d-block.small {',
    '  color: #eb8f00 !important;',
    '}',

    /* --- Course tab navigation (Course/Progress/Dates/Teams) --- */
    /* The learning MFE uses .nav-link without .nav-tabs wrapper */
    '.nav-link.active {',
    '  color: #004337 !important;',
    '  border-bottom: 3px solid #eb8f00 !important;',
    '  font-weight: 700 !important;',
    '}',
    '.nav-link:not(.active):hover {',
    '  color: #eb8f00 !important;',
    '  border-bottom-color: rgba(235,143,0,0.35) !important;',
    '}',

    /* --- Sequence / tabs navigation (top) --- */
    '.sequence-navigation,',
    '[class*="SequenceNavigation"] {',
    '  background-color: #ffffff !important;',
    '  border-bottom: 1px solid #e5e7eb !important;',
    '}',
    /* Active tab underline */
    '.sequence-navigation__tab--active,',
    '[class*="SequenceNavigation"] .active {',
    '  border-bottom: 3px solid #eb8f00 !important;',
    '  color: #004337 !important;',
    '  font-weight: 700 !important;',
    '}',
    /* Completion circle active */
    '.sequence-navigation__item.complete .sequence-navigation__link,',
    '.sequence-navigation .unit-icon.complete {',
    '  color: #004337 !important;',
    '}',
    /* Active unit bullet */
    '.sequence-navigation__item.active .sequence-navigation__link {',
    '  color: #eb8f00 !important;',
    '  font-weight: 600 !important;',
    '}',

    /* --- Course outline / sidebar --- */
    '.course-outline-sidebar,',
    '.course-navigation,',
    '[class*="CourseOutline"] aside,',
    '[class*="CourseSidebar"] {',
    '  background-color: #f8f9fa !important;',
    '  border-right: 1px solid #e5e7eb !important;',
    '}',

    /* Chapter/section title */
    '.course-outline-chapter .chapter-title,',
    '.course-outline-chapter h3,',
    '[class*="Section"] h3 {',
    '  color: #004337 !important;',
    '  font-weight: 700 !important;',
    '}',

    /* Active chapter highlight */
    '.course-outline-chapter.is-open,',
    '.course-outline-chapter.active {',
    '  border-left: 3px solid #eb8f00 !important;',
    '}',
    '.course-outline-chapter.is-open .chapter-title,',
    '.course-outline-chapter.active .chapter-title {',
    '  color: #eb8f00 !important;',
    '}',

    /* Unit link items */
    '.course-outline-unit a,',
    '[class*="UnitButton"] {',
    '  color: #374151 !important;',
    '  transition: color 0.15s ease !important;',
    '}',
    '.course-outline-unit a:hover,',
    '[class*="UnitButton"]:hover {',
    '  color: #eb8f00 !important;',
    '}',
    /* Active unit */
    '.course-outline-unit.active a,',
    '[class*="UnitButton"].active {',
    '  color: #eb8f00 !important;',
    '  font-weight: 600 !important;',
    '}',

    /* --- Completion checkmark icon --- */
    '.completion-icon,',
    '[class*="CompletionIcon"] {',
    '  color: #004337 !important;',
    '  fill: #004337 !important;',
    '}',

    /* --- Course progress bar (sidebar) --- */
    '.course-completion-progress .progress-bar,',
    '.sidebar .progress-bar {',
    '  background-color: #eb8f00 !important;',
    '}',
    '.course-completion-percentage {',
    '  color: #004337 !important;',
    '  font-weight: 700 !important;',
    '}',

    /* --- Next / Previous / Continue buttons --- */
    '.sequence-navigation__next,',
    '.sequence-navigation__previous,',
    '[class*="NextButton"], [class*="PreviousButton"],',
    '.btn-complete-unit {',
    '  border-radius: 6px !important;',
    '  font-weight: 600 !important;',
    '}',
    '.sequence-navigation__next,',
    '[class*="NextButton"] {',
    '  background-color: #004337 !important;',
    '  border-color: #004337 !important;',
    '  color: #ffffff !important;',
    '}',
    '.sequence-navigation__next:hover, [class*="NextButton"]:hover {',
    '  background-color: #002e26 !important;',
    '  border-color: #002e26 !important;',
    '  color: #ffffff !important;',
    '}',

    /* --- Mark complete button --- */
    '.btn-mark-complete,',
    '[class*="MarkComplete"] {',
    '  background-color: #004337 !important;',
    '  border-color: #004337 !important;',
    '  color: #ffffff !important;',
    '  border-radius: 6px !important;',
    '  font-weight: 600 !important;',
    '}',
    '.btn-mark-complete:hover, [class*="MarkComplete"]:hover {',
    '  background-color: #eb8f00 !important;',
    '  border-color: #eb8f00 !important;',
    '}',

    /* --- Lock / paywall icon --- */
    '.lock-paywall,',
    '[class*="LockPaywall"],',
    '[class*="locked-icon"] {',
    '  color: #eb8f00 !important;',
    '}',

    /* --- Courseware content area --- */
    '.courseware-sequence-content,',
    '[class*="SequenceContent"] {',
    '  background-color: #ffffff !important;',
    '  border-radius: 8px !important;',
    '  box-shadow: 0 1px 8px rgba(0,0,0,0.04) !important;',
    '}',

    /* --- Breadcrumb: course name --- */
    '.breadcrumb-item a {',
    '  color: #eb8f00 !important;',
    '}',
    '.breadcrumb-item.active { color: #374151 !important; }',
  ].join('\n');

  if (document.getElementById('tba-learning-styles')) return;
  var style = document.createElement('style');
  style.id = 'tba-learning-styles';
  style.textContent = LEARNING_CSS;
  document.head.appendChild(style);
  console.log('[TBA] Learning MFE styles injected');
})();
    }
    if (process.env.APP_ID == 'ora-grading') {
    }
    if (process.env.APP_ID == 'profile') {// TBA - Affichage du champ "Profil" sur la page de profil utilisateur
(function() {
  const TBA_PROFIL_CHOICES = {
    'actionnaire':              'Actionnaire',
    'cadre_dirigeant':          'Cadre dirigeant',
    'collegien_lyceen':         'Collégien / Lycéen',
    'ecolier':                  'Écolier',
    'etudiant':                 'Étudiant',
    'fonctionnaire':            'Fonctionnaire',
    'salarie':                  'Salarié',
    'profession_liberale':      'Profession libérale',
    'investisseur_particulier': 'Investisseur particulier',
    'journaliste':              'Journaliste',
  };

  function getLmsBase() {
    return window.location.origin.replace('apps.', '');
  }

  function getUsernameFromPath() {
    var match = window.location.pathname.match(/\/u\/([^/]+)/);
    return match ? match[1] : null;
  }

  function fetchProfilValue(username, callback) {
    fetch(getLmsBase() + '/api/user/v1/accounts/' + username, {
      credentials: 'include',
      headers: { 'Accept': 'application/json' }
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var ext = data.extended_profile || [];
      var field = ext.find(function(f) { return f.field_name === 'tba_profil'; });
      callback(field ? field.field_value : '');
    })
    .catch(function() { callback(''); });
  }

  function buildProfilBadge(value) {
    var label = TBA_PROFIL_CHOICES[value] || value;
    var wrapper = document.createElement('div');
    wrapper.id = 'tba-profile-profil-badge';
    wrapper.style.cssText = 'margin-top: .5rem; display: flex; align-items: center; gap: .4rem;';

    var icon = document.createElement('span');
    icon.textContent = '🏷';
    icon.style.fontSize = '1rem';

    var text = document.createElement('span');
    text.style.cssText = 'font-size: .9rem; color: #555; font-weight: 500;';
    text.textContent = label;

    wrapper.appendChild(icon);
    wrapper.appendChild(text);
    return wrapper;
  }

  function injectProfileProfilBadge() {
    if (!window.location.pathname.includes('/u/')) return;
    if (document.getElementById('tba-profile-profil-badge')) return;

    var username = getUsernameFromPath();
    if (!username) return;

    // Find the full-name <p> element or any username indicator, use its parent as anchor
    var anchor = null;

    // Strategy: find <p> whose text matches the username or fullname pattern in .profile-page
    var profilePage = document.querySelector('.profile-page');
    if (!profilePage) return;

    var allP = Array.from(profilePage.querySelectorAll('p'));
    // Prefer the paragraph with the full name (longer text, not the @username)
    var nameP = allP.find(function(p) {
      var t = p.textContent.trim();
      return t.length > 3 && !t.includes('@') && p.className.includes('font-weight');
    }) || allP[0];

    if (nameP) {
      anchor = nameP.parentNode;
    } else {
      // Fallback: use the first child div of .profile-page
      anchor = profilePage.querySelector('div div div div') || profilePage;
    }

    if (!anchor) return;

    fetchProfilValue(username, function(value) {
      if (!value) return;
      if (document.getElementById('tba-profile-profil-badge')) return;
      anchor.appendChild(buildProfilBadge(value));
      console.log('[TBA] Badge Profil "' + value + '" injecté dans page profil');
    });
  }

  var _observer = new MutationObserver(function() {
    if (window.location.pathname.includes('/u/')) injectProfileProfilBadge();
  });

  function start() {
    if (document.body) {
      _observer.observe(document.body, { childList: true, subtree: true });
      injectProfileProfilBadge();
    } else {
      setTimeout(start, 50);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
    }
  } catch (err) { console.error("env.config.jsx failed to apply: ", err);}

  return config;
}

export default setConfig;